import React, { useContext, useEffect, useState } from "react";
import "./Event_section.css";
import Event_card from "./event_card/Event_card";
import Down_Arrow_Lottie from "../../../animation/Down_Arrow_Lottie/Down_Arrow_Lottie";
import Heading_banner_section from "../../../common_components/heading_banner/Heading_banner_section";
import Event_Modal from "../../../common_components/event_Modal/Event_Modal";
import { Event } from "../../../../utils/luxuryapis/Event/Event";
import { Context } from "../../../../utils/context";

function Event_section() {
  const [modalShow, setModalShow] = React.useState(false);

 

  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "EVENTS" },
  ];

  const { IMG_URL } = useContext(Context);
  const [data, setData] = useState([]);
  const [singleData, setSingleData] = useState({});
  const getData = async () => {
    const res = await Event();
    if (res?.success) {
      setData(res?.data?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  const [showAll, setShowAll] = useState(false);
  return (
    <>
      <section className="Event_section">
        <Heading_banner_section
          headingText={"EVENTS"}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="custom_container">
          <div className="card_section">
            <div className="row me-0 ms-0">
              {data
                ?.slice(0, showAll ? data.length : 10)
                ?.map((item, index) => (
                  <div
                    className="  col-xl-3 col-md-4 col-sm-6  col-6 mb-3"
                    key={index}
                  >
                    <Event_card
                      imgSrc={IMG_URL + item.event_images?.[0]?.image}
                      cardHeading={item?.name}
                      onClick={() => {
                        setModalShow(true);
                        setSingleData(item);
                      }}
                    />
                  </div>
                ))}
            </div>

            {data?.length > 10 && !showAll && (
              <div
                className="view_all_text_holder"
                onClick={() => setShowAll(true)}
                style={{ cursor: "pointer" }}
              >
                <p>VIEW ALL EVENTS</p>
                <Down_Arrow_Lottie />
              </div>
            )}
          </div>
        </div>
      </section>
      <Event_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        data={singleData}
        IMG_URL={IMG_URL}
      />
    </>
  );
}

export default Event_section;
